class ProgressBar extends HTMLElement {
  constructor() {
    super();
  }

  static get attributes() {
    return {
      valueMax: "aria-valuemax",
      valueNow: "aria-valuenow"
    }
  }

  static get observedAttributes() {
    return [
      this.attributes.valueMax,
      this.attributes.valueNow
    ];
  }

  set valueMax(value) {
    this.setAttribute(ProgressBar.attributes.valueMax, value);
  }

  set valueNow(value) {
    this.setAttribute(ProgressBar.attributes.valueNow, value);
  }

  attributeChangedCallback() {
    const progress = Math.min(1, this.getAttribute(ProgressBar.attributes.valueNow) / this.getAttribute(ProgressBar.attributes.valueMax));

    this.style.setProperty(
      "--progress",
      `${progress}`
    );
  }
}

if (!customElements.get("progress-bar")) {
  customElements.define("progress-bar", ProgressBar);
}
